<script setup lang="ts">
  import { useI18n } from "vue-i18n";
  import { Text, Button } from "@ui-kit";
  import { Image } from "@src/components";
  import { DateService } from "@src/services";

  const { image_url, title, article, color, link_created } = defineProps<{
    image_url: string;
    title: string;
    article: string;
    color?: string;
    link_created?: string;
  }>();
  const emit = defineEmits<{ (e: "click:unlink"): void }>();

  const i18n = useI18n();
</script>

<template>
  <div class="found-item">
    <div class="found-item__content">
      <Image :url="image_url" />
      <div class="found-item__info">
        <Text font="body-medium-16">{{ title }}</Text>
        <Text font="body-regular-14" color="secondary">
          {{ `${article}, ${color}` }}
        </Text>
        <Text v-if="link_created" font="body-regular-12" color="error">
          {{ DateService.formatDateWithTime(link_created, i18n.locale.value) }}
        </Text>
      </div>
    </div>
    <Button size="s" variant="secondary" data-testid="found-item-unlink-btn" @click="emit('click:unlink')">
      {{ $t("Удалить из зоны") }}
    </Button>
  </div>
</template>

<style scoped>
  .found-item {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);

    & :deep(.button) {
      width: 100%;
    }
  }

  .found-item__content {
    display: flex;
    gap: 12px;

    & :deep(.image) {
      width: 48px;
      height: 62px;
    }
  }

  .found-item__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
</style>
